
const drink = [
    {
        id: 1,
        name: 'Lassi : ラッシー',
        price: '¥300'
    },
    {
        id: 2,
        name: 'Orange Juice : オレンジジュース',
        price: '¥300'
    },
    {
        id: 3,
        name: 'Chai : チャイ',
        price: '¥300'
    },
    {
      id: 4,
      name: 'Mango Lassi : マンゴーラッシー',
      price: '¥300'
    },
    {
      id: 5,
      name: 'Cola : コーラ',
      price: '¥300'
    },
    {
      id: 6,
      name: 'Apple Juice : アップルジュース',
      price: '¥300'
    }
];

export default drink;